import { render } from "./Alfred.vue?vue&type=template&id=6d6ffe82&scoped=true"
import script from "./Alfred.vue?vue&type=script&lang=js"
export * from "./Alfred.vue?vue&type=script&lang=js"

import "./Alfred.vue?vue&type=style&index=0&id=6d6ffe82&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6ffe82"]])

export default __exports__